export default __webpack_public_path__ + "static/media/1899.4c1abb28.png";